module.exports = __webpack_public_path__ + "static/media/ltc.cdae0850.svg";